function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  "class": "pp-shell"
};
var _hoisted_2 = {
  key: 0,
  "class": "pp-embed-hero"
};
var _hoisted_3 = {
  "class": "pp-layout"
};
var _hoisted_4 = {
  "class": "pp-stack"
};
var _hoisted_5 = {
  "class": "pp-card pp-panel"
};
var _hoisted_6 = {
  "class": "pp-grid2"
};
var _hoisted_7 = {
  "class": "pp-field"
};
var _hoisted_8 = {
  "class": "pp-label"
};
var _hoisted_9 = {
  "class": "pp-tip"
};
var _hoisted_10 = {
  "class": "pp-inwrap pp-field-input"
};
var _hoisted_11 = ["value"];
var _hoisted_12 = ["value"];
var _hoisted_13 = {
  "class": "pp-grid2 pp-top-gap"
};
var _hoisted_14 = {
  "class": "pp-seg pp-top-gap-sm"
};
var _hoisted_15 = {
  "class": "pp-seg pp-top-gap-sm"
};
var _hoisted_16 = {
  "class": "pp-stack-sm pp-top-gap"
};
var _hoisted_17 = {
  key: 0,
  "class": "pp-warning"
};
var _hoisted_18 = {
  "class": "pp-note pp-faint"
};
var _hoisted_19 = {
  "class": "pp-advanced"
};
var _hoisted_20 = {
  "class": "pp-advanced-title"
};
var _hoisted_21 = {
  key: 0,
  "class": "pp-grid2 pp-top-gap"
};
var _hoisted_22 = {
  "class": "pp-card pp-panel"
};
var _hoisted_23 = {
  "class": "pp-disp pp-section-head"
};
var _hoisted_24 = {
  "class": "pp-note pp-faint"
};
var _hoisted_25 = {
  "class": "pp-stack-xs"
};
var _hoisted_26 = {
  "class": "pp-compare-track"
};
var _hoisted_27 = {
  "class": "pp-num pp-compare-value"
};
var _hoisted_28 = {
  "class": "pp-result-col"
};
var _hoisted_29 = {
  "class": "pp-hero-head"
};
var _hoisted_30 = {
  "class": "pp-hero-label"
};
var _hoisted_31 = {
  "class": "pp-hero-metrics"
};
var _hoisted_32 = {
  "class": "pp-num pp-hero-metric-value"
};
var _hoisted_33 = {
  "class": "pp-num pp-hero-metric-value"
};
var _hoisted_34 = {
  key: 0
};
var _hoisted_35 = {
  "class": "pp-num pp-hero-metric-value"
};
var _hoisted_36 = {
  "class": "pp-top-gap-lg"
};
var _hoisted_37 = {
  "class": "pp-segment-bar"
};
var _hoisted_38 = ["title"];
var _hoisted_39 = {
  "class": "pp-legend"
};
var _hoisted_40 = {
  "class": "pp-card pp-panel"
};
var _hoisted_41 = {
  "class": "pp-breakdown-group"
};
var _hoisted_42 = {
  "class": "pp-breakdown-block"
};
var _hoisted_43 = {
  "class": "pp-breakdown-block"
};
var _hoisted_44 = {
  "class": "pp-breakdown-foot"
};
var _hoisted_45 = {
  key: 0,
  "class": "pp-note pp-faint"
};
var _hoisted_46 = {
  key: 0,
  "class": "pp-card pp-panel"
};
var _hoisted_47 = {
  "class": "pp-disp pp-section-head"
};
var _hoisted_48 = {
  "class": "pp-output-card pp-top-gap"
};
var _hoisted_49 = {
  "class": "pp-output-label"
};
var _hoisted_50 = {
  "class": "pp-num pp-disp pp-output-value"
};
var _hoisted_51 = {
  key: 0,
  "class": "pp-output-note pp-faint"
};
var _hoisted_52 = {
  key: 1,
  "class": "pp-card pp-panel pp-embed-card"
};
var _hoisted_53 = ["value"];
var _hoisted_54 = {
  "class": "pp-embed-actions"
};
var _hoisted_55 = {
  key: 2,
  "class": "pp-powered"
};
var _hoisted_56 = {
  "class": "pp-modal-card"
};
var _hoisted_57 = {
  "class": "pp-modal-head"
};
var _hoisted_58 = {
  "class": "pp-modal-body"
};
var _hoisted_59 = {
  "class": "pp-preview-wrap"
};
var _hoisted_60 = ["src"];
import { computed, defineComponent, h, reactive, ref } from 'vue';
import { TOOL_EMBED_PROPS, buildEmbedSnippet, useToolEmbedSupport } from './shared/toolEmbed';
import { useTimedFlag, writeToClipboard } from './shared/toolClipboard';
var FF_CARD = 0.029;
export default {
  __name: 'paypalFeeCalculator',
  props: TOOL_EMBED_PROPS,
  setup: function setup(__props) {
    var props = __props;
    var BRAND = {
      brand: '#0072d6',
      brand600: '#0061b6',
      brandSoft: '#e8f2fc',
      ring: '#cce3f7',
      ink: '#222a44',
      text: '#1f1f1f',
      muted: '#5d6772',
      faint: '#99a1ac',
      line: '#e4e8ee',
      bg: '#f4f7fa',
      surface: '#ffffff',
      pos: '#00c489',
      pos700: '#0a8a63',
      posSoft: '#e6f8f1',
      neg: '#ff492c',
      negSoft: '#ffe9e4',
      warn: '#ffa127',
      warnSoft: '#fff2e0',
      pink: '#ff3969'
    };
    var MARKETS = {
      us: {
        name: 'United States',
        cur: 'USD',
        sym: '$',
        dom: 0.0349,
        intl: 0.0499,
        fixed: 0.49,
        conv: 0.04,
        ffIntl: 4.99
      },
      uk: {
        name: 'United Kingdom',
        cur: 'GBP',
        sym: '£',
        dom: 0.029,
        intl: 0.0489,
        fixed: 0.30,
        conv: 0.04,
        ffIntl: 3.99
      },
      eu: {
        name: 'Eurozone (EU)',
        cur: 'EUR',
        sym: '€',
        dom: 0.029,
        intl: 0.0489,
        fixed: 0.35,
        conv: 0.04,
        ffIntl: 3.99
      },
      au: {
        name: 'Australia',
        cur: 'AUD',
        sym: '$',
        dom: 0.026,
        intl: 0.041,
        fixed: 0.30,
        conv: 0.04,
        ffIntl: 4.99
      },
      ca: {
        name: 'Canada',
        cur: 'CAD',
        sym: '$',
        dom: 0.029,
        intl: 0.044,
        fixed: 0.30,
        conv: 0.04,
        ffIntl: 4.99
      },
      nz: {
        name: 'New Zealand',
        cur: 'NZD',
        sym: '$',
        dom: 0.034,
        intl: 0.044,
        fixed: 0.45,
        conv: 0.03,
        ffIntl: 6.99
      },
      sg: {
        name: 'Singapore',
        cur: 'SGD',
        sym: '$',
        dom: 0.039,
        intl: 0.044,
        fixed: 0.50,
        conv: 0.03,
        ffIntl: 4.99
      },
      my: {
        name: 'Malaysia',
        cur: 'MYR',
        sym: 'RM',
        dom: 0.039,
        intl: 0.044,
        fixed: 2.00,
        conv: 0.025,
        ffIntl: 4.99
      },
      row: {
        name: 'Rest of world (standard)',
        cur: 'USD',
        sym: '$',
        dom: 0.034,
        intl: 0.044,
        fixed: 0.30,
        conv: 0.03,
        ffIntl: 4.99
      },
      latam: {
        name: 'Latin America & Caribbean',
        cur: 'USD',
        sym: '$',
        dom: 0.054,
        intl: 0.054,
        fixed: 0.30,
        conv: 0.035,
        ffIntl: 4.99
      },
      gulf: {
        name: 'Gulf & select markets',
        cur: 'USD',
        sym: '$',
        dom: 0.049,
        intl: 0.049,
        fixed: 0.30,
        conv: 0.03,
        ffIntl: 4.99
      }
    };
    var MARKET_ORDER = ['us', 'uk', 'eu', 'au', 'ca', 'nz', 'sg', 'my', 'row', 'latam', 'gulf'];
    var ICONS = {
      info: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 10
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 16v-4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 8h.01'
        }
      }],
      chevronDown: [{
        tag: 'path',
        attrs: {
          d: 'm6 9 6 6 6-6'
        }
      }],
      chevronRight: [{
        tag: 'path',
        attrs: {
          d: 'm9 18 6-6-6-6'
        }
      }],
      rotateCcw: [{
        tag: 'path',
        attrs: {
          d: 'M3 2v6h6'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M3 8a9 9 0 1 0 3-6.7L3 4'
        }
      }],
      copy: [{
        tag: 'rect',
        attrs: {
          x: 9,
          y: 9,
          width: 13,
          height: 13,
          rx: 2,
          ry: 2
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'
        }
      }],
      check: [{
        tag: 'path',
        attrs: {
          d: 'M20 6 9 17l-5-5'
        }
      }],
      alertTriangle: [{
        tag: 'path',
        attrs: {
          d: 'm10.29 3.86-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.71-3.14l-8-14a2 2 0 0 0-3.42 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 9v4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M12 17h.01'
        }
      }],
      target: [{
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 10
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 6
        }
      }, {
        tag: 'circle',
        attrs: {
          cx: 12,
          cy: 12,
          r: 2
        }
      }],
      layers: [{
        tag: 'path',
        attrs: {
          d: 'm12.83 2.18 8 4a1 1 0 0 1 0 1.64l-8 4a2 2 0 0 1-1.66 0l-8-4a1 1 0 0 1 0-1.64l8-4a2 2 0 0 1 1.66 0Z'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm2 12 9.17 4.59a2 2 0 0 0 1.66 0L22 12'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm2 16 9.17 4.59a2 2 0 0 0 1.66 0L22 16'
        }
      }],
      arrowLeftRight: [{
        tag: 'path',
        attrs: {
          d: 'M8 3 4 7l4 4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M4 7h16'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm16 21 4-4-4-4'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'M20 17H4'
        }
      }],
      x: [{
        tag: 'path',
        attrs: {
          d: 'M18 6 6 18'
        }
      }, {
        tag: 'path',
        attrs: {
          d: 'm6 6 12 12'
        }
      }]
    };
    var SvgIcon = defineComponent({
      name: 'PaypalSvgIcon',
      inheritAttrs: false,
      props: {
        name: {
          type: String,
          required: true
        },
        size: {
          type: [Number, String],
          "default": 24
        }
      },
      setup: function setup(componentProps, _ref) {
        var attrs = _ref.attrs;
        return function () {
          var nodes = ICONS[componentProps.name] || [];
          return h('svg', _objectSpread(_objectSpread({}, attrs), {}, {
            xmlns: 'http://www.w3.org/2000/svg',
            width: componentProps.size,
            height: componentProps.size,
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': 2,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round',
            'aria-hidden': 'true'
          }), nodes.map(function (node, index) {
            return h(node.tag, _objectSpread({
              key: "".concat(componentProps.name, "-").concat(index)
            }, node.attrs));
          }));
        };
      }
    });
    var FieldInput = defineComponent({
      name: 'PaypalFieldInput',
      props: {
        label: {
          type: String,
          required: true
        },
        hint: {
          type: String,
          "default": ''
        },
        modelValue: {
          type: [Number, String],
          "default": 0
        },
        prefix: {
          type: String,
          "default": ''
        },
        suffix: {
          type: String,
          "default": ''
        },
        step: {
          type: [String, Number],
          "default": '0.01'
        }
      },
      emits: ['update:modelValue'],
      setup: function setup(componentProps, _ref2) {
        var emit = _ref2.emit;
        function onInput(event) {
          var nextValue = event.target.value;
          var parsed = Number.parseFloat(nextValue);
          emit('update:modelValue', nextValue === '' || Number.isNaN(parsed) ? 0 : Math.max(0, parsed));
        }
        return function () {
          return h('label', {
            "class": 'pp-field'
          }, [h('span', {
            "class": 'pp-label'
          }, [componentProps.label, componentProps.hint ? h('span', {
            "class": 'pp-tip'
          }, [h(SvgIcon, {
            name: 'info',
            size: 14,
            style: {
              color: BRAND.faint
            }
          }), h('span', {
            "class": 'b'
          }, componentProps.hint)]) : null]), h('div', {
            "class": 'pp-inwrap pp-field-input'
          }, [componentProps.prefix ? h('span', {
            "class": 'pp-pre'
          }, componentProps.prefix) : null, h('input', {
            "class": 'pp-num',
            type: 'number',
            inputmode: 'decimal',
            step: componentProps.step,
            min: '0',
            value: componentProps.modelValue,
            onInput: onInput
          }), componentProps.suffix ? h('span', {
            "class": 'pp-pre pp-suffix'
          }, componentProps.suffix) : null])]);
        };
      }
    });
    var ToggleCard = defineComponent({
      name: 'PaypalToggleCard',
      props: {
        label: {
          type: String,
          required: true
        },
        hint: {
          type: String,
          "default": ''
        },
        checked: {
          type: Boolean,
          "default": false
        }
      },
      emits: ['update:checked'],
      setup: function setup(componentProps, _ref3) {
        var emit = _ref3.emit;
        return function () {
          return h('button', {
            type: 'button',
            role: 'switch',
            'aria-checked': componentProps.checked,
            "class": 'pp-chip pp-toggle-card',
            onClick: function onClick() {
              return emit('update:checked', !componentProps.checked);
            }
          }, [h('span', {
            "class": 'pp-toggle-text'
          }, [componentProps.label, componentProps.hint ? h('span', {
            "class": 'pp-toggle-hint'
          }, " \xB7 ".concat(componentProps.hint)) : null]), h('span', {
            "class": ['pp-switch', {
              on: componentProps.checked
            }]
          }, [h('i')])]);
        };
      }
    });
    var BreakdownRow = defineComponent({
      name: 'PaypalBreakdownRow',
      props: {
        label: {
          type: String,
          required: true
        },
        value: {
          type: String,
          required: true
        },
        sub: {
          type: String,
          "default": ''
        },
        tone: {
          type: String,
          "default": 'default'
        },
        strong: {
          type: Boolean,
          "default": false
        }
      },
      setup: function setup(componentProps) {
        return function () {
          var color = componentProps.tone === 'neg' ? BRAND.neg : componentProps.tone === 'pos' ? BRAND.pos700 : componentProps.strong ? BRAND.ink : BRAND.muted;
          return h('div', {
            "class": 'pp-row'
          }, [h('span', {
            "class": 'pp-row-label',
            style: {
              color: componentProps.strong ? BRAND.ink : BRAND.muted,
              fontWeight: componentProps.strong ? 600 : 400
            }
          }, [componentProps.label, componentProps.sub ? h('span', {
            "class": 'pp-row-sub'
          }, componentProps.sub) : null]), h('span', {
            "class": ['pp-num', 'pp-row-value', {
              'pp-row-value-strong': componentProps.strong
            }],
            style: {
              color: color
            }
          }, componentProps.value)]);
        };
      }
    });
    function calc(state) {
      var market = MARKETS[state.market] || MARKETS.row;
      var amount = state.amount;
      var conversionRate = state.convert ? market.conv : 0;
      var pctRate = 0;
      var pctFee = 0;
      var fixedFee = 0;
      var convFee = 0;
      var surcharge = 0;
      var fee = 0;
      var net = amount;
      var senderPays = amount;
      if (state.type === 'gs') {
        pctRate = state.intl ? market.intl : market.dom;
        if (state.rateOverride > 0) {
          pctRate = state.rateOverride / 100;
        }
        var fixed = state.fixedOverride > 0 ? state.fixedOverride : market.fixed;
        pctFee = amount > 0 ? pctRate * amount : 0;
        fixedFee = amount > 0 ? fixed : 0;
        convFee = amount > 0 ? conversionRate * amount : 0;
        surcharge = state.intl && amount > 0 ? (market.intl - market.dom) * amount : 0;
        fee = pctFee + fixedFee + convFee;
        net = amount - fee;
        senderPays = amount;
      } else {
        var intlFixed = state.intl ? market.ffIntl : 0;
        pctRate = state.cardFunded ? FF_CARD : 0;
        pctFee = state.cardFunded ? FF_CARD * amount : 0;
        fixedFee = (state.cardFunded ? market.fixed : 0) + intlFixed;
        convFee = state.convert ? conversionRate * amount : 0;
        fee = pctFee + fixedFee + convFee;
        net = amount;
        senderPays = amount + fee;
      }
      return {
        cur: market.cur,
        sym: market.sym,
        pctRate: pctRate,
        pctFee: pctFee,
        fixedFee: fixedFee,
        convFee: convFee,
        surcharge: surcharge,
        fee: fee,
        net: net,
        senderPays: senderPays,
        effRate: amount > 0 ? fee / amount : 0
      };
    }
    function grossFor(target, state) {
      var market = MARKETS[state.market] || MARKETS.row;
      var rate = state.intl ? market.intl : market.dom;
      if (state.rateOverride > 0) {
        rate = state.rateOverride / 100;
      }
      var fixed = state.fixedOverride > 0 ? state.fixedOverride : market.fixed;
      var conversionRate = state.convert ? market.conv : 0;
      var denominator = 1 - rate - conversionRate;
      return denominator > 0 ? (target + fixed) / denominator : Infinity;
    }
    function money(value, symbol) {
      return Number.isFinite(value) ? "".concat(symbol).concat(value.toLocaleString('en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })) : '—';
    }
    function pct(value) {
      return Number.isFinite(value) ? "".concat((value * 100).toFixed(2).replace(/\.?0+$/, ''), "%") : '—';
    }
    function notAchievable(value) {
      return !(value < 9000000);
    }
    var defaults = {
      amount: 100,
      market: 'us',
      type: 'gs',
      intl: false,
      convert: false,
      cardFunded: false,
      rateOverride: 0,
      fixedOverride: 0
    };
    var blank = _objectSpread(_objectSpread({}, defaults), {}, {
      amount: 0
    });
    var inputs = reactive(_objectSpread({}, defaults));
    var showAdvanced = ref(false);
    var targetNet = ref(100);
    var _useTimedFlag = useTimedFlag(1500),
      copied = _useTimedFlag.flag,
      triggerCopied = _useTimedFlag.trigger,
      resetCopied = _useTimedFlag.reset;
    var _useTimedFlag2 = useTimedFlag(1500),
      embedCopied = _useTimedFlag2.flag,
      triggerEmbedCopied = _useTimedFlag2.trigger,
      resetEmbedCopied = _useTimedFlag2.reset;
    var _useToolEmbedSupport = useToolEmbedSupport({
        props: props
      }),
      rootRef = _useToolEmbedSupport.rootRef,
      previewFrameRef = _useToolEmbedSupport.previewFrameRef,
      showPreview = _useToolEmbedSupport.showPreview,
      isEmbed = _useToolEmbedSupport.isEmbed,
      pageUrl = _useToolEmbedSupport.pageUrl,
      previewSrc = _useToolEmbedSupport.previewSrc,
      showEmbedCard = _useToolEmbedSupport.showEmbedCard,
      closePreview = _useToolEmbedSupport.closePreview;
    function setValue(key, value) {
      inputs[key] = value;
    }
    var market = computed(function () {
      return MARKETS[inputs.market] || MARKETS.row;
    });
    var symbol = computed(function () {
      return market.value.sym;
    });
    var isFF = computed(function () {
      return inputs.type === 'ff';
    });
    var result = computed(function () {
      return calc(inputs);
    });
    var gross = computed(function () {
      return grossFor(targetNet.value, inputs);
    });
    var hasBasis = computed(function () {
      return inputs.amount > 0;
    });
    var fmt = function fmt(value) {
      return money(value, symbol.value);
    };
    var heroStyle = computed(function () {
      return isFF.value ? {
        background: "linear-gradient(135deg, ".concat(BRAND.brandSoft, ", #fff)"),
        border: "1px solid ".concat(BRAND.brand, "22")
      } : {
        background: "linear-gradient(135deg, ".concat(BRAND.posSoft, ", #fff)"),
        border: "1px solid ".concat(BRAND.pos, "33")
      };
    });
    var heroLabel = computed(function () {
      return isFF.value ? 'Fee to send (sender pays)' : 'Receiving';
    });
    var heroValue = computed(function () {
      return isFF.value ? result.value.fee : result.value.net;
    });
    var heroColor = computed(function () {
      return isFF.value ? BRAND.brand600 : BRAND.pos700;
    });
    var segments = computed(function () {
      return isFF.value ? [{
        label: 'Fee to send',
        value: Math.max(result.value.fee, 0),
        color: BRAND.pink
      }, {
        label: 'Recipient gets',
        value: result.value.net,
        color: BRAND.pos
      }] : [{
        label: 'PayPal fee',
        value: Math.max(result.value.fee, 0),
        color: BRAND.pink
      }, {
        label: 'Receiving',
        value: Math.max(result.value.net, 0),
        color: BRAND.pos
      }];
    });
    var segmentTotal = computed(function () {
      return segments.value.reduce(function (total, segment) {
        return total + segment.value;
      }, 0) || 1;
    });
    var embedSnippet = computed(function () {
      return buildEmbedSnippet({
        pageUrl: pageUrl.value,
        iframeTitle: 'PayPal Fee Calculator by SaleHoo',
        initialHeight: 1500
      });
    });
    function copySummary() {
      return _copySummary.apply(this, arguments);
    }
    function _copySummary() {
      _copySummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text, didCopy;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              text = isFF.value ? ['PayPal Friends & Family — estimate', "".concat(market.value.name, " \xB7 ").concat(inputs.intl ? 'international' : 'domestic').concat(inputs.cardFunded ? ' · card-funded' : ' · balance/bank'), "Send ".concat(fmt(inputs.amount), " \u2192 fee to sender ").concat(fmt(result.value.fee), "; recipient gets ").concat(fmt(result.value.net)), "Sender pays ".concat(fmt(result.value.senderPays), " total")].join('\n') : ['PayPal Goods & Services — estimate', "".concat(market.value.name, " \xB7 ").concat(inputs.intl ? 'international' : 'domestic').concat(inputs.convert ? ' · currency converted' : ''), "Payment ".concat(fmt(inputs.amount), "  \xB7  fee ").concat(fmt(result.value.fee), " (").concat(pct(result.value.effRate), ")"), "Receiving ".concat(fmt(result.value.net))].join('\n');
              _context.next = 3;
              return writeToClipboard(text);
            case 3:
              didCopy = _context.sent;
              if (didCopy) {
                _context.next = 7;
                break;
              }
              resetCopied();
              return _context.abrupt("return");
            case 7:
              triggerCopied();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _copySummary.apply(this, arguments);
    }
    function copyEmbed() {
      return _copyEmbed.apply(this, arguments);
    }
    function _copyEmbed() {
      _copyEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var didCopy;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return writeToClipboard(embedSnippet.value);
            case 2:
              didCopy = _context2.sent;
              if (didCopy) {
                _context2.next = 6;
                break;
              }
              resetEmbedCopied();
              return _context2.abrupt("return");
            case 6:
              triggerEmbedCopied();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _copyEmbed.apply(this, arguments);
    }
    function resetData() {
      Object.assign(inputs, blank);
      targetNet.value = 0;
      showAdvanced.value = false;
      resetCopied();
      resetEmbedCopied();
      showPreview.value = false;
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        "class": _normalizeClass(['pp', {
          embed: _unref(isEmbed)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_unref(isEmbed) ? (_openBlock(), _createElementBlock("header", _hoisted_2, _cache[16] || (_cache[16] = [_createElementVNode("h1", {
        "class": "pp-disp"
      }, " PayPal Fee Calculator ", -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("section", _hoisted_5, [_cache[23] || (_cache[23] = _createElementVNode("h2", {
        "class": "pp-disp pp-section-title"
      }, " Sending ", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(FieldInput), {
        label: isFF.value ? 'Amount to send' : 'Payment amount',
        prefix: symbol.value,
        hint: isFF.value ? 'What you send to friends or family.' : "The amount the buyer pays you. PayPal's fee comes out of this.",
        "model-value": inputs.amount,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return setValue('amount', $event);
        })
      }, null, 8, ["label", "prefix", "hint", "model-value"]), _createElementVNode("label", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_cache[18] || (_cache[18] = _createTextVNode(" Your PayPal account is in ")), _createElementVNode("span", _hoisted_9, [_createVNode(_unref(SvgIcon), {
        name: "info",
        size: 14,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[17] || (_cache[17] = _createElementVNode("span", {
        "class": "b"
      }, "Fees are set by the country your PayPal account is registered in, and the currency you receive.", -1))])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("select", {
        value: inputs.market,
        onChange: _cache[1] || (_cache[1] = function ($event) {
          return setValue('market', $event.target.value);
        })
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(MARKET_ORDER, function (key) {
        return _createElementVNode("option", {
          key: key,
          value: key
        }, _toDisplayString(MARKETS[key].name) + " (" + _toDisplayString(MARKETS[key].cur) + ") ", 9, _hoisted_12);
      }), 64))], 40, _hoisted_11)])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        "class": "pp-sub-label"
      }, "Payment type", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
        type: "button",
        "class": _normalizeClass({
          on: inputs.type === 'gs'
        }),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return setValue('type', 'gs');
        })
      }, " Goods & services ", 2), _createElementVNode("button", {
        type: "button",
        "class": _normalizeClass({
          on: inputs.type === 'ff'
        }),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return setValue('type', 'ff');
        })
      }, " Friends & family ", 2)])]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("span", {
        "class": "pp-sub-label"
      }, "Where's the other person?", -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
        type: "button",
        "class": _normalizeClass({
          on: !inputs.intl
        }),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return setValue('intl', false);
        })
      }, " Same country ", 2), _createElementVNode("button", {
        type: "button",
        "class": _normalizeClass({
          on: inputs.intl
        }),
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return setValue('intl', true);
        })
      }, " Another country ", 2)])])]), _createElementVNode("div", _hoisted_16, [isFF.value ? (_openBlock(), _createBlock(_unref(ToggleCard), {
        key: 0,
        label: "Funded by a card",
        hint: "balance/bank is free domestically",
        checked: inputs.cardFunded,
        "onUpdate:checked": _cache[6] || (_cache[6] = function ($event) {
          return setValue('cardFunded', $event);
        })
      }, null, 8, ["checked"])) : _createCommentVNode("", true), _createVNode(_unref(ToggleCard), {
        label: "Payment converted to my currency",
        hint: "adds ~".concat(pct(market.value.conv)),
        checked: inputs.convert,
        "onUpdate:checked": _cache[7] || (_cache[7] = function ($event) {
          return setValue('convert', $event);
        })
      }, null, 8, ["hint", "checked"])]), isFF.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_unref(SvgIcon), {
        name: "alertTriangle",
        size: 14,
        "class": "pp-warning-icon",
        style: _normalizeStyle({
          color: BRAND.warn
        })
      }, null, 8, ["style"]), _cache[21] || (_cache[21] = _createElementVNode("span", null, "Friends & Family has no buyer or seller protection, and using it for a sale breaks PayPal's terms. For anything you're selling, use Goods & Services.", -1))])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_18, _toDisplayString(isFF.value ? "".concat(market.value.name, ": friends & family is free when funded by balance or bank and sent within the same country. Cards and cross-border payments add a fee, paid by the sender.") : "".concat(market.value.name, ": ").concat(pct(inputs.intl ? market.value.intl : market.value.dom), " + ").concat(fmt(market.value.fixed), " on this payment").concat(inputs.intl ? ' (includes the international rate)' : '', ".")), 1), _createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
        type: "button",
        "class": "pp-advanced-toggle",
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return showAdvanced.value = !showAdvanced.value;
        })
      }, [_createElementVNode("span", _hoisted_20, [_createVNode(_unref(SvgIcon), {
        name: "layers",
        size: 16,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[22] || (_cache[22] = _createTextVNode(" Advanced options "))]), _createVNode(_unref(SvgIcon), {
        name: showAdvanced.value ? 'chevronDown' : 'chevronRight',
        size: 16
      }, null, 8, ["name"])]), showAdvanced.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_unref(FieldInput), {
        label: "Override rate %",
        hint: "Got a negotiated or micropayment rate? Enter the percentage to override the table.",
        prefix: "",
        suffix: "%",
        step: "0.01",
        "model-value": inputs.rateOverride,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return setValue('rateOverride', $event);
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(FieldInput), {
        label: "Override fixed fee",
        hint: "Override the per-transaction fixed fee charged in your currency.",
        prefix: symbol.value,
        "model-value": inputs.fixedOverride,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return setValue('fixedOverride', $event);
        })
      }, null, 8, ["prefix", "model-value"])])) : _createCommentVNode("", true)])]), _createElementVNode("section", _hoisted_22, [_createElementVNode("h2", _hoisted_23, [_createVNode(_unref(SvgIcon), {
        name: "arrowLeftRight",
        size: 16,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[24] || (_cache[24] = _createTextVNode(" Same payment, domestic vs international "))]), _createElementVNode("p", _hoisted_24, " What the cross-border rate does to your take-home on a " + _toDisplayString(fmt(inputs.amount)) + " goods & services payment. ", 1), _createElementVNode("div", _hoisted_25, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([['Domestic', false], ['International', true]], function (comparison) {
        return _createElementVNode("div", {
          key: comparison[0],
          "class": "pp-compare-row"
        }, [_createElementVNode("span", {
          "class": "pp-compare-label",
          style: _normalizeStyle({
            color: inputs.intl === comparison[1] && !isFF.value ? BRAND.ink : BRAND.muted,
            fontWeight: inputs.intl === comparison[1] && !isFF.value ? 700 : 400
          })
        }, _toDisplayString(comparison[0]), 5), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
          "class": "pp-compare-fill",
          style: _normalizeStyle({
            width: "".concat(Math.max(0, Math.min(100, calc(_objectSpread(_objectSpread({}, inputs), {}, {
              type: 'gs',
              intl: comparison[1]
            })).net / (calc(_objectSpread(_objectSpread({}, inputs), {}, {
              type: 'gs',
              intl: false
            })).net || 1)) * 100), "%"),
            background: comparison[1] ? '#9fe2cb' : BRAND.pos
          })
        }, null, 4)]), _createElementVNode("span", _hoisted_27, _toDisplayString(fmt(calc(_objectSpread(_objectSpread({}, inputs), {}, {
          type: 'gs',
          intl: comparison[1]
        })).net)), 1)]);
      }), 64))])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("section", {
        "class": "pp-hero-card",
        style: _normalizeStyle(heroStyle.value)
      }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(heroLabel.value), 1), _createElementVNode("button", {
        type: "button",
        "class": "pp-btn pp-copy-btn",
        onClick: copySummary
      }, [_createVNode(_unref(SvgIcon), {
        name: _unref(copied) ? 'check' : 'copy',
        size: 12,
        style: _normalizeStyle(_unref(copied) ? {
          color: BRAND.pos
        } : {})
      }, null, 8, ["name", "style"]), _createTextVNode(" " + _toDisplayString(_unref(copied) ? 'Copied' : 'Copy'), 1)])]), _createElementVNode("div", {
        "class": "pp-num pp-disp pp-hero-value",
        style: _normalizeStyle({
          color: heroColor.value
        })
      }, _toDisplayString(fmt(heroValue.value)), 5), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(isFF.value ? 'Sender pays' : "PayPal's cut") + " ", 1), _createElementVNode("b", _hoisted_32, _toDisplayString(isFF.value ? fmt(result.value.senderPays) : fmt(result.value.fee)), 1)]), _createElementVNode("span", null, [_cache[25] || (_cache[25] = _createTextVNode("Effective ")), _createElementVNode("b", _hoisted_33, _toDisplayString(pct(result.value.effRate)), 1)]), isFF.value ? (_openBlock(), _createElementBlock("span", _hoisted_34, [_cache[26] || (_cache[26] = _createTextVNode("Recipient gets ")), _createElementVNode("b", _hoisted_35, _toDisplayString(fmt(result.value.net)), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("div", {
          key: segment.label,
          "class": "pp-segment-fill",
          style: _normalizeStyle({
            width: "".concat(segment.value / segmentTotal.value * 100, "%"),
            background: segment.color
          }),
          title: "".concat(segment.label, ": ").concat(fmt(segment.value))
        }, null, 12, _hoisted_38);
      }), 128))]), _createElementVNode("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments.value, function (segment) {
        return _openBlock(), _createElementBlock("span", {
          key: segment.label,
          "class": "pp-legend-item"
        }, [_createElementVNode("span", {
          "class": "pp-legend-swatch",
          style: _normalizeStyle({
            background: segment.color
          })
        }, null, 4), _createTextVNode(" " + _toDisplayString(segment.label) + " " + _toDisplayString(fmt(segment.value)), 1)]);
      }), 128))])])], 4), _createElementVNode("section", _hoisted_40, [_cache[27] || (_cache[27] = _createElementVNode("h2", {
        "class": "pp-disp pp-section-title"
      }, " Fee breakdown ", -1)), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(_unref(BreakdownRow), {
        label: isFF.value ? 'Amount sent' : 'Payment amount',
        value: fmt(inputs.amount),
        strong: ""
      }, null, 8, ["label", "value"])]), _createElementVNode("div", _hoisted_43, [result.value.pctFee > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 0,
        label: "Percentage fee",
        sub: pct(result.value.pctRate),
        value: "\u2013 ".concat(fmt(result.value.pctFee)),
        tone: "neg"
      }, null, 8, ["sub", "value"])) : _createCommentVNode("", true), result.value.fixedFee > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 1,
        label: isFF.value && inputs.intl ? 'Fixed + cross-border fee' : 'Fixed fee',
        value: "\u2013 ".concat(fmt(result.value.fixedFee)),
        tone: "neg"
      }, null, 8, ["label", "value"])) : _createCommentVNode("", true), result.value.convFee > 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 2,
        label: "Currency conversion",
        sub: pct(market.value.conv),
        value: "\u2013 ".concat(fmt(result.value.convFee)),
        tone: "neg"
      }, null, 8, ["sub", "value"])) : _createCommentVNode("", true), result.value.fee === 0 ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 3,
        label: "No PayPal fee",
        sub: "balance/bank, same country",
        value: fmt(0),
        tone: "pos"
      }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(_unref(BreakdownRow), {
        label: isFF.value ? 'Total fee (sender)' : 'Total PayPal fee',
        value: "".concat(isFF.value ? '' : '– ').concat(fmt(result.value.fee)),
        tone: isFF.value ? 'default' : 'neg',
        strong: ""
      }, null, 8, ["label", "value", "tone"])]), _createElementVNode("div", _hoisted_44, [_createVNode(_unref(BreakdownRow), {
        label: isFF.value ? 'Recipient receives' : 'Receiving',
        value: fmt(result.value.net),
        tone: "pos",
        strong: ""
      }, null, 8, ["label", "value"]), isFF.value ? (_openBlock(), _createBlock(_unref(BreakdownRow), {
        key: 0,
        label: "Sender pays in total",
        value: fmt(result.value.senderPays),
        strong: ""
      }, null, 8, ["value"])) : _createCommentVNode("", true)])]), inputs.intl && !isFF.value ? (_openBlock(), _createElementBlock("p", _hoisted_45, " International adds " + _toDisplayString(fmt(result.value.surcharge)) + " versus the domestic rate on this payment. ", 1)) : _createCommentVNode("", true)]), !isFF.value ? (_openBlock(), _createElementBlock("section", _hoisted_46, [_createElementVNode("h2", _hoisted_47, [_createVNode(_unref(SvgIcon), {
        name: "target",
        size: 16,
        style: _normalizeStyle({
          color: BRAND.faint
        })
      }, null, 8, ["style"]), _cache[28] || (_cache[28] = _createTextVNode(" What should I charge? "))]), _createVNode(_unref(FieldInput), {
        label: "Amount I want to receive",
        prefix: symbol.value,
        "model-value": targetNet.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return targetNet.value = $event;
        })
      }, null, 8, ["prefix", "model-value"]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, " Ask the buyer for this, and the fee leaves you with " + _toDisplayString(fmt(targetNet.value)), 1), _createElementVNode("div", _hoisted_50, _toDisplayString(!(hasBasis.value || targetNet.value > 0) ? '—' : notAchievable(gross.value) ? 'Not achievable' : fmt(gross.value)), 1), (hasBasis.value || targetNet.value > 0) && !notAchievable(gross.value) ? (_openBlock(), _createElementBlock("div", _hoisted_51, " PayPal takes " + _toDisplayString(fmt(gross.value - targetNet.value)) + " of that. ", 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("button", {
        type: "button",
        "class": "pp-btn pp-reset",
        onClick: resetData
      }, [_createVNode(_unref(SvgIcon), {
        name: "rotateCcw",
        size: 14
      }), _cache[29] || (_cache[29] = _createTextVNode(" Reset data "))])])]), _unref(showEmbedCard) ? (_openBlock(), _createElementBlock("section", _hoisted_52, [_cache[30] || (_cache[30] = _createElementVNode("h2", {
        "class": "pp-disp pp-section-title pp-section-title-tight"
      }, " Add calculator to your site ", -1)), _cache[31] || (_cache[31] = _createElementVNode("p", {
        "class": "pp-embed-note pp-faint"
      }, " Copy the snippet and paste it into any page or blog post. It resizes to fit and works on mobile. ", -1)), _createElementVNode("textarea", {
        "class": "pp-embed-code pp-num",
        readonly: "",
        rows: "4",
        value: embedSnippet.value,
        "aria-label": "Embed code",
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return $event.target.select();
        })
      }, null, 8, _hoisted_53), _createElementVNode("div", _hoisted_54, [_createElementVNode("button", {
        type: "button",
        "class": "pp-btn pp-embed-copy",
        style: _normalizeStyle({
          background: BRAND.brand,
          color: '#fff',
          borderColor: BRAND.brand
        }),
        onClick: copyEmbed
      }, [_createVNode(_unref(SvgIcon), {
        name: _unref(embedCopied) ? 'check' : 'copy',
        size: 14
      }, null, 8, ["name"]), _createTextVNode(" " + _toDisplayString(_unref(embedCopied) ? 'Copied' : 'Copy embed code'), 1)], 4), _createElementVNode("button", {
        type: "button",
        "class": "pp-btn pp-embed-preview",
        onClick: _cache[13] || (_cache[13] = function ($event) {
          return showPreview.value = !_unref(showPreview);
        })
      }, _toDisplayString(_unref(showPreview) ? 'Hide preview' : 'Preview embed'), 1)])])) : _createCommentVNode("", true), _unref(isEmbed) ? (_openBlock(), _createElementBlock("p", _hoisted_55, _cache[32] || (_cache[32] = [_createTextVNode(" Powered by "), _createElementVNode("a", {
        href: "https://www.salehoo.com",
        target: "_blank",
        rel: "noopener"
      }, "SaleHoo", -1)]))) : _createCommentVNode("", true)]), _unref(showPreview) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "pp-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "paypal-preview-title",
        onClick: _cache[15] || (_cache[15] = _withModifiers(function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        }, ["self"]))
      }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_cache[33] || (_cache[33] = _createElementVNode("h3", {
        id: "paypal-preview-title",
        "class": "pp-disp"
      }, " Embed preview ", -1)), _createElementVNode("button", {
        type: "button",
        "class": "pp-modal-close",
        "aria-label": "Close preview",
        onClick: _cache[14] || (_cache[14] = function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        })
      }, [_createVNode(_unref(SvgIcon), {
        name: "x",
        size: 14
      })])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("iframe", {
        ref_key: "previewFrameRef",
        ref: previewFrameRef,
        "class": "pp-preview-frame",
        src: _unref(previewSrc),
        title: "Embed preview",
        loading: "lazy"
      }, null, 8, _hoisted_60)])])])])) : _createCommentVNode("", true)], 2);
    };
  }
};